module.exports = __webpack_public_path__ + "img/NewsCenter_pic4.73df7d61.png";